import axiosInstance from '../../../config/axiosInstance';
import type {
  PVProfessionalMonthlyControl,
  PVProfessionalReserveSuggestionResult,
  PVProfessionalReserveSuggestionWrite,
  PVProfessionalSettings,
  PVProfessionalSettingsWrite,
} from '../types/projectVitalProfessionalControl';

export async function getPVProfessionalSettings(): Promise<PVProfessionalSettings> {
  const { data } = await axiosInstance.get('/project-vital/finance/professional/settings');
  return data as PVProfessionalSettings;
}

export async function updatePVProfessionalSettings(
  payload: PVProfessionalSettingsWrite,
): Promise<PVProfessionalSettings> {
  const { data } = await axiosInstance.put(
    '/project-vital/finance/professional/settings',
    payload,
  );
  return data as PVProfessionalSettings;
}

export async function getPVProfessionalMonthlyControl(
  month: string,
): Promise<PVProfessionalMonthlyControl> {
  const { data } = await axiosInstance.get(
    '/project-vital/finance/professional/monthly-control',
    { params: { month } },
  );
  return data as PVProfessionalMonthlyControl;
}

export async function createPVProfessionalSuggestedReserves(
  month: string,
  payload: PVProfessionalReserveSuggestionWrite,
): Promise<PVProfessionalReserveSuggestionResult> {
  const { data } = await axiosInstance.post(
    `/project-vital/finance/professional/monthly-control/${month}/reserves`,
    payload,
  );
  return data as PVProfessionalReserveSuggestionResult;
}
